import { useEffect, useState } from 'react';
import { getAdministratedPartners } from '../api/getAdministratedPartners';

export type PartnerBasic = {
  _id: string;
  name: string;
  email: string;
  cif: string;
};

export const useGetPartnersFromAdministrated = (userId: string) => {
  const [partnersFromAdministrated, setPartnersFromAdministrated] = useState<
    PartnerBasic[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchPartners = async () => {
      if (!userId) return;

      setIsLoading(true);

      try {
        const currentPartners = (await getAdministratedPartners(
          userId
        )) as PartnerBasic[];

        setPartnersFromAdministrated(currentPartners);
      } catch (error) {
        setPartnersFromAdministrated([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPartners();
  }, [userId]);

  return { partnersFromAdministrated, isLoading };
};
